import RegulationDesktop from '../../pages/regulation/RegulationDesktop'
import RegulationMobile from '../../pages/regulation/RegulationMobile'

const regulation = {
  path: '/regulation',
  name: 'Regulation',
  component: window.innerWidth >= 1025 ? RegulationDesktop : RegulationMobile,
  meta: {
    title: 'Page Title',
  },
}

export default regulation
